export default __webpack_public_path__ + "static/toolshub_shop-a3f031719c3e4aadf6f7ebb3c6130cfa.png";